export default __webpack_public_path__ + "static/media/comment_medium.096f8fc0.png";